<div class="layout-default">    
    <div style="flex: 1; display: flex; flex-direction: column;">
        <div style="background-color: #1E88E5; flex-basis: 10%;"></div>
        <div style="background-color: #ff5252; flex: 1;"></div>
        <div style="background-color: #1EE56A; flex-basis: 10%;"></div>
    </div>
</div>


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-3.html